import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { parseQueryParameters } from '../../functions/parse-query-params.function';
import { catchError, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private httpClient: HttpClient) { }

  processApiUri(apiStr: string): string {
    if (apiStr.startsWith('/')) {
      apiStr = apiStr.substring(1, apiStr.length);
    }

    if(apiStr.endsWith('/')){
      apiStr = apiStr.substring(0, apiStr.length - 1);
    }

    return apiStr;
  }

  processGWUri(gwStr: string): string {
    if (!gwStr.endsWith('/')) {
      gwStr += "/";
    }
    return gwStr;
  }

  getRequest<T>(gateway: string, api: string, paramsBody: T = {} as T) {
    const url = gateway + api + parseQueryParameters(paramsBody as Object);
    const headers = this.getHeaders('', api, parseQueryParameters(paramsBody as Object))
    const options = { headers };
    return this.httpClient.get(url, options).pipe(
      catchError(this.handleError.bind(this)),
      tap(res => res)
    )
  }

  getNoAuth<T>(gateway: string, api: string, paramsBody: T = {} as T) {
    const url = gateway + api + parseQueryParameters(paramsBody as Object);
    return this.httpClient.get(url).pipe(
      catchError(this.handleError.bind(this)),
      tap(res => res)
    )
  }

  postRequestParams<T extends Record<string, any>>(gateway: string, api: string, paramsBody: T = {} as T) {
    const url = gateway + api;
  
    let body = new HttpParams();
    Object.keys(paramsBody).forEach((key) => {
      const value = paramsBody[key];
      if (value !== undefined && value !== null) {
        body = body.append(key, encodeURIComponent(String(value)));
      }
    });
  
    const headers = this.getHeaders('post', api, paramsBody);
    const options = {
      headers,
      body
    };
  
    return this.httpClient.post<T>(url, body, options).pipe(
      catchError(this.handleError.bind(this)),
      tap(res => res)
    );
  }

  private handleError(errRes: HttpErrorResponse) {
    let msg: string = errRes.error.message || errRes.message;
    return throwError(msg);
  }

  getHeaders(type = "", url = "", params?: any) {
    if (!(typeof params === "string" || params instanceof String)) {
      params = JSON.stringify(params);
    }
    if(url.startsWith('/'))
    url = url.substring(1, url.length);

    switch (type) {
      case 'post':
        return new HttpHeaders({
          "Content-Type": "application/x-www-form-urlencoded",
        });
    
      default:
        return new HttpHeaders({
          "Content-Type": "application/json; charset=UTF-8",
          "Content-Signature":
            environment.authParams.username +
            ":" +
            this.generateHash(
              environment.authParams.username + "/v2/" + url + params
            ),
          // 'Authorization': this.authorization
        });
    }

  }

  generateHash(body: any) {
    const hash = CryptoJS.HmacSHA256(  body, environment.authParams.RequestHmacKey );
    return CryptoJS.enc.Base64.stringify(hash);
  }
}
